<template>
  <v-main>
    <AppBar/>
    <v-layout fill-height column>
      <v-container flex-fill fluid class="pb-0">
        <div class="account-title-block">
          <h1 class="tit">소속회사 정보</h1>
          <p class="desc">
            본인이 소속해 있는 회사정보를 설정해주세요
          </p>
        </div>
        <v-form class="form-item" v-model="valid">
          <label class="label">회사명</label>
          <div class="input-group">
            <v-text-field solo flat filled v-model="clientNm" required readonly/>
          </div>
          <label class="label">직무</label>
          <div class="input-group">
            <v-select
                :items="jobItems"
                item-value="jobNo"
                item-text="jobName"
                v-model="selectedJob"
                required
                label="직무를 선택해주세요."
                solo
                filled
                single-line
                background-color="#F7F7F7"/>
          </div>

          <label class="label">직급</label>
          <div class="input-group">
            <v-select
                :items="pstItems"
                item-value="pstNo"
                item-text="pstName"
                v-model="selectedPst"
                required
                label="직급를 선택해주세요."
                solo
                filled
                single-line
                background-color="#F7F7F7"/>
          </div>
          <label class="label">부서</label>
          <div class="input-group">
            <v-text-field solo flat filled v-model="department" placeholder="부서명"/>
          </div>
        </v-form>
      </v-container>
      <v-footer app fixed color="white" class="content-footer">
        <div class="footer-btns">
          <BlackBtn x-large str="다음" :disabled="!valid" @click="doSave"/>
        </div>
      </v-footer>
    </v-layout>
  </v-main>
</template>
<script>
import BlackBtn from "@/components/btns/BlackBtn";
import store from "@/store";
import {mixinAuth} from "@/mixins";

export default {
  data: () => ({
    valid: false,
    clientNm: '',
    job: '',
    position: '',
    department: '',
    jobItems: [],
    pstItems: [], //직급
    selectedJob: null,
    selectedPst: null,
    jobNo: '',
    pstNo: '',
    departNm: '',
  }),
  mixins: [mixinAuth],
  components: {
    BlackBtn,
  },
  computed: {
  },
  created() {
    this.getJobList();
    this.getPstList();
    this.clientNm = this.memberInfo.clientNm;
    this.selectedJob = this.memberInfo.jobNo;
    this.selectedPst = this.memberInfo.pstNo;
    this.department = this.memberInfo.depart;
  },
  mounted() {
  },
  methods: {

    //직급조회
    async getPstList() {
      let outParam = {
        clientNo: this.clientCd
      };
      await store.dispatch('getPstList', this.$_payload("ctClientPst", outParam))
          .then(res => {
            if (res.success) {
              this.pstItems = res.data;
            } else {
              this.pstItems = [];
            }
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
          });
    },

    //직무조회
    async getJobList() {
      let outParam = {
        clientNo: this.clientCd
      };

      await store.dispatch('getJobList', this.$_payload("ctClientJob", outParam))
          .then(res => {
            if (res.success) {
              this.jobItems = res.data;
            } else {
              this.jobItems = [];
            }

          }).catch(error => {
            console.error(error)
          }).finally(() => {
          });
    },
    async doSave() {

      let outParam = {
        jobNo: this.selectedJob,
        pstNo: this.selectedPst,
        depart: this.department
      }

		await store.dispatch('setMemberInfo', this.$_payload('inData',outParam))
          .then(res => {
            if (res.success) {
              store.commit('setMemberInfo', outParam)
              this.$root.$children[0].$refs.toast.toastOpen('top', '변경이 완료되었습니다.');
              //this.movePage('/fo/myInfo');
              this.prevPage()
            }
          }).catch(error => {
            console.error(error)
          }).finally(() => {
          });


    },

  }
}
</script>
